// utils/secureFetch.js

/**
 * Universal authenticated fetch wrapper for Redux async actions.
 * Automatically pulls token from Redux and applies JSON headers.
 */
export const secureFetch = async ({ method = 'GET', url, body = null, getState }) => {
  const token = getState().auth.token;

  const res = await fetch(url, {
    method,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    ...(body && { body: JSON.stringify(body) })
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`HTTP ${res.status}: ${errorText}`);
  }

  return await res.json();
};
